import Form from './Form';
import Stripe from './Stripe';

/*
 * Model class Payment
 */
export default class Payment extends Stripe {
	constructor(pricing, payment_type, content, sce, stripe) {
		super(pricing, payment_type, content, sce, stripe);
			
		this.payment_type 	= payment_type;
		this.form 			= new Form();
		this.content 		= content;
		this.sce 			= sce;
		this.steps 			= [
			{
				position 	: 'first',
				status 		: '',
				icon		: 'fa fa-cog',
				active 		: true,
				alias 		: 'account_setup',
				name		: content['account-setup'],
				title		: content['account-setup-title'],
				submit 		: content['continue-btn'],
				submit_pay	: false,
				onsubmit 	: false,
				saved 		: {}
			},
			{
				position 	: 'second',
				status 		: '',
				active 		: false,
				icon		: 'fa fa-user',
				alias 		: 'profile_setup',
				name		: content['profile-setup'],
				title		: content['profile-setup-title'],
				submit 		: content['continue-btn'],
				submit_pay	: false,
				onsubmit 	: false,
				saved 		: {}
			},
			{
				position 	: 'third',
				status 		: '',
				active 		: false,
				icon		: 'fa fa-credit-card',
				name		: content['billing-setup'],
				title		: content['billing-setup-title'],
				submit 		: content['pay-btn'],
				submit_pay	: true,
				onsubmit 	: true,
				saved 		: {}
			},
			{
				position: 'last',
				status 		: '',
				active 		: false,
				icon		: 'fa fa-rocket',
				name		: content.confirm,
				title		: content['confirm-title'],
				submit 		: content.confirm,
				submit_pay	: false,
				onsubmit 	: false,
				saved 		: {}
			},
		];
    }

	get_steps(pos, single = false) {
		var steps 	= [],
			json 	=  JSON.parse(JSON.stringify(this.steps));

		for (var i in json) {
			steps[i] = json[i];

			if (i < (pos - 1)) {
				steps[i].status = 'done';
				steps[i].icon = 'fa fa-check';
				steps[i].active = true;
			}

			if (i == (pos - 1)) {
				steps[i].status = 'active';
				steps[i].active = true;
			}
		}

		if (single) {
			return this.steps[pos - 1];
		}

		return steps;
	}

	get_form(step) {
		var form 	= {
				title 		: this.steps[step - 1].title,
				submit		: this.steps[step - 1].submit,
				submit_pay	: this.steps[step - 1].submit_pay,
				onsubmit 	: this.steps[step - 1].onsubmit,
				fields 		: [],
				html		: ''
			},
			details = {};

		switch (step) {
			case 1 :
				details = this.account_details();
			break;

			case 2 :
				details = this.profile_setup();
			break;

			case 3 :
				details = this.billing_setup();
			break;
		}

		if (details.html !== undefined) {
			form.html = details.html;
			form.fields = details.fields;
		}

		return form;
	}

	account_details() {
		var fields 	= [
				{label : `${this.content['account-setup-email']} *`, name : 'email', type : 'text', required: true, error: {valid: this.content['invalid-email'], empty: this.content['field-empty']}},
				{label : `${this.content['account-setup-password']} *`, name : 'password', type	: 'password', required: true, error: {empty: this.content['field-empty']}},
				{label : `${this.content['account-setup-confirm']} *`, name : 'confirm_password', type : 'password', required: true, error: {empty: this.content['field-empty']}}
			];

		return this.return_html(fields);
	}

	profile_setup() {
		var fields 	= [
				{label : `${this.content['profile-setup-firstname']} *`, name : 'first_name', type : 'text', required: true, error: {empty: this.content['field-empty']}},
				{label : `${this.content['profile-setup-surname']} *`, name : 'surname', type : 'text', required: true, error: {empty: this.content['field-empty']}},
				{label : `${this.content['profile-setup-phone']} *`, name : 'phone', type : 'text', required: true, error: {empty: this.content['field-empty']}}
			];

		return this.return_html(fields);
	}

	billing_setup() {
		var fields 	= [
				{label : `${this.content['billing-setup-card-name']} *`, name : 'card_name', type : 'text', required: true},
				{label : `${this.content['billing-setup-card-number']} *`, name : 'card_number', type : 'text', required: true},
				{label : `${this.content['billing-setup-card-cvc']} *`, name : 'cvc', type : 'text', required: true},
				{label : `${this.content['billing-setup-card-expiry']} *`, name : 'expiration', type : 'text', required: true}
			];

		var html = `<div class="col-md-6 col-md-offset-3">
						<div class="form-group">
							<div class="row">
								<svg class="credit-cards cc-unknown"><use xlink:href="#cc-unknown" /></svg>
							</div>
							<div class="form-row">
								<div id="card-element"></div>
								<div id="card-errors" role="alert"></div>
							</div>
						</div>
						<div class="form-group">
							<div class="form-row">
								<div id="card-expiry"></div>
								<div id="card-expiry-errors" role="alert"></div>
							</div>
						</div>
						<div class="form-group">
							<div class="form-row">
								<div id="card-cvc"></div>
								<div id="card-cvc-errors" role="alert"></div>
							</div>
						</div>
					</div>
					
					<svg width="119" height="26"><use xlink:href="#pay-with-stripe-logo" /></svg>`;

		return {fields: fields, html: html};
	}

	complete() {
		return {html: ''};
	}

	confirm_details() {
		var last_step	= this.steps[(this.steps.length - 1)],
			html 		= `<div class="col-md-12">
								<div class="row">
									<h4>${this.content['payment-successful']}, <a href="/user/login"><u>${this.content['payment-successful-click-here']}</u></a></h4>
								</div>
							</div>`;

		return {title:last_step.title, submit:last_step.submit, html:html};
	}

	return_html(fields) {
		var html = "";

		for (var i in fields) {
			var field 	= fields[i],
				label 	= this.form.combine_input('label', '', field.label, 3),
				input 	= this.form.combine_input(field.type, field.name, '', 6, field.required),
				group 	= this.form.form_group(label + input);

			html += group;
		}

		return {fields: fields, html: html};
	}

	save_details(post, step) {
		this.steps[step - 1].saved = post;
	}
	
	process_payment_form(post) {
		return new Promise((resolve, reject)=> {
			$.post('/user/process_payment_form/', post, function(data){
				resolve(data);
			});
		});
	}
	
	validate(field, value) {
		return this.form.validate(field, value);
	}
}
